import { useState } from 'react';
import { TooltipProps } from './tooltip.interface';
import * as S from './tooltip.styles';

const Tooltip = ({ text, children, position = 'bottom', width = 100 }: TooltipProps) => {
  const [onHover, setOnHover] = useState<boolean>(false);

  return (
    <S.Wrapper
      onMouseOver={() => {
        setOnHover(true);
      }}
      onMouseLeave={() => {
        setOnHover(false);
      }}
    >
      <S.Tooltip $width={width} $position={position} $onHover={onHover}>
        {text}
      </S.Tooltip>
      {children}
    </S.Wrapper>
  );
};

export default Tooltip;
